module.exports = __webpack_public_path__ + "static/media/no-img.4b0bd202.png";